import { TIGHT_KNIT_API_BASE_PATH } from '../Config/Environment';

export const apiConstants = {
    routes: {
        SERVER: TIGHT_KNIT_API_BASE_PATH
    },
    methods: {
        GET: 'GET',
        POST: 'POST',
        PUT: 'PUT',
        DELETE: 'DELETE',
    },
    headers: {
        JSON: 'application/json',
        ContentType: 'Content-Type',
        Authorization: 'Authorization',
    },
};

export async function processServerResponse(response: Response): Promise<any> {
    if (response.status === 204) {
        return;
    } else {
        return response
        .json()
        .catch(err => {
            console.log(err);
            return Promise.reject('invalid response from server');
        })
        .then(json => {
            if ((response.status >= 400 && response.status <= 600) || json.success === false) {
                return Promise.reject(json.error || json.message || 'server error');
            }
            return json;
        });
    }

}



// WEBPACK FOOTER //
// ./src/util/apiUtils.ts